import Vue from "vue";

Vue.filter("ucFirst", (string) => string.charAt(0).toUpperCase() + string.slice(1));

Vue.filter("capitalLetter", (string) => (string ? string.charAt(0).toUpperCase() : ""));

Vue.filter("sanitize", (string) => string.replace(/_/g, " "));

// noinspection JSUnresolvedFunction
Vue.filter("capitalize", (string) =>
  string
    .toLowerCase()
    .split(" ")
    .map((word) => word.replace(word[0], word[0].toUpperCase()))
    .join(" ")
);

Vue.filter("trimLeadingZeros", (string) => string.replace(/^0+/, ""));

Vue.filter("jobStatusClass", (job) => {
  if (job && job.status) {
    return `status-${job.status.split(" ").join("-").toLowerCase()}`;
  }

  return "";
});
